export const titleClasses = 'flex justify-between items-center cursor-pointer'
